import * as React from "react";
import { useIsLargerThan } from "@tiny/theme/utils";
import { useLocation } from "react-router-dom";
import TopMenu from "../../components/Sidebar/TopMenu";
import SamCartTopMenu from "../../components/Sidebar/TopMenu/SamCartTopMenu";
import MobileNavigation from "../../components/MobileMenu";
import { useAccountProvider } from "../../providers/hooks";

function Navigation({
  openMenu,
  toggleNavigation,
}: {
  openMenu: boolean;
  toggleNavigation: () => void;
}) {
  const isMobile = useIsLargerThan("sm");
  const provider = useAccountProvider();
  const location = useLocation();

  const hideNavigationRoutes = [
    /^\/main\/campaigns\/[^/]+\/edit/,
    /^\/main\/automations\/[^/]+\/edit/,
    /^\/main\/campaigns\/builder/,
  ];

  const shouldHideNavigation = hideNavigationRoutes.some((pattern) =>
    pattern.test(location.pathname)
  );

  if (shouldHideNavigation) {
    return null;
  }

  if (!isMobile) {
    return (
      <MobileNavigation openMenu={openMenu} toggleMenu={toggleNavigation} />
    );
  }

  return provider === "samcart" ? <SamCartTopMenu /> : <TopMenu />;
}

export default Navigation;
